<template>

  <layout-header></layout-header>

  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->

  <div class="page-wrapper">

    <div class="content">

      <!-- Breadcrumb -->

      <div

        class="d-md-flex d-block align-items-center justify-content-between mb-3"

      >

        <breadcrumb :title="title" :text="text" :text1="text1" />

      </div>

      <!-- /Breadcrumb -->



      <employee-dashboard-welcome />



      <employee-dashboard-attention />



      <employee-dashboard-quick-actions />



      <employee-top></employee-top>



      <employee-dashboard-latest-payslip />



      <employee-dashboard-minimal-hint />



      <attendence-employee v-if="showAttendanceDashboard" />



      <employee-task v-if="showProjectsTasks" />



      <!-- <employee-performance></employee-performance>



      <team-member></team-member> -->

    </div>

    <div

      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"

    >

      <p class="mb-0">

        2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll

      </p>

      <p>

        Powered by

        <a href="#" @click.prevent class="text-primary"

          >DoneQuick Technological World</a

        >

      </p>

    </div>

  </div>

  <employee-dashboard-modal></employee-dashboard-modal>

  <!-- /Page Wrapper -->

</template>



<script setup>

import EmployeeDashboardWelcome from "@/views/pages/dashboard/employee-dashboard/employee-dashboard-welcome.vue";

import EmployeeDashboardAttention from "@/views/pages/dashboard/employee-dashboard/employee-dashboard-attention.vue";

import EmployeeDashboardQuickActions from "@/views/pages/dashboard/employee-dashboard/employee-dashboard-quick-actions.vue";

import EmployeeDashboardLatestPayslip from "@/views/pages/dashboard/employee-dashboard/employee-dashboard-latest-payslip.vue";

import EmployeeDashboardMinimalHint from "@/views/pages/dashboard/employee-dashboard/employee-dashboard-minimal-hint.vue";

import { useEmployeeDashboardAccess } from "@/composables/useEmployeeDashboardAccess";



const title = "Employee Dashboard";

const text = "Dashboard";

const text1 = "Employee Dashboard";



const { showAttendanceDashboard, showProjectsTasks } =

  useEmployeeDashboardAccess();

</script>


